import { Common } from '../common';

import { LabelingJob, FilterOptions } from '../models/predict/labeling';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getJobQueue(
    options: FilterOptions,
  ): Promise<LabelingJob[] | undefined> {
    const url = this.common.constructPath(`/predict/labeling-jobs`, options);
    const response = this.common.getJSON(url);
    return response;
  }

  async claimJob(jobId: string) {
    const url = this.common.constructPath(`predict/labeling-jobs/${jobId}`);
    const response = this.common.patchJSON(url);
    return response;
  }

  async cancelJob(jobId: string) {
    const url = this.common.constructPath(`predict/labeling-jobs/${jobId}`);
    const response = this.common.deleteJSON(url);
    return response;
  }

  async disclaimJob(jobId: string) {
    const url = this.common.constructPath(
      `predict/labeling-jobs/${jobId}/user`,
    );
    const response = this.common.deleteJSON(url);
    return response;
  }
}
